<template>
<div id="recuperaciones_ws">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
        <v-row align-center justify-center>
            <v-col sm="12">
                <base-material-card color="primary" icon="library_books" title="Recuperaciones de eDocuments" class="elevation-1 px-5 py-3">
                    <v-tabs grow style="margin-bottom: 30px;">
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab :key="'in-view'">Generar Consulta</v-tab>
                        <v-tab :key="'in-report'">Consultas Programadas</v-tab>

                        <v-tab-item :key="'in-view'">
                            <v-card-text>
                                <v-card-title>
                                    <span class="headline"></span>
                                </v-card-title>
                                <v-form ref="form1" lazy-validation>
                                    <v-container grid-list-md text-xs-center>
                                         <v-row>
                                            <v-col cols="12" sm="4">
                                        <v-text-field label="Número de Referencia" type="text" 
                                                        v-model="model.descripcion"  :rules="[rules.required]"></v-text-field>
                                          </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="4">
                                               <v-switch
                                                    v-model="sellos_patente"
                                                    color="red darken-3" 
                                                    label="Sellos de Agente"
                                                ></v-switch>
                                                <v-autocomplete v-if="sellos_patente" clearable item-value="id" item-text="text" chips small-chips no-data-text="No se localizaron sellos de patentes" :items="patentes" v-model="patente" label="Patente" :hide-no-data="false" ></v-autocomplete>
                                            
                                                
                                            </v-col>
                                            <v-col cols="12" sm="8">
                                               
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="4">
                                     
                                                <h5>Ingrese lista de eDocuments</h5>
                                                <v-textarea outlined rows="15" v-model="listado"></v-textarea>
                                            </v-col>
                                            <v-col cols="12" sm="8">
                                                 <v-btn v-if="model.descripcion !='' && ((sellos_patente && patente > 0 && listado != '' ) || (!sellos_patente && listado != '' ))" rounded color="red" @click="crearproceso" :loading="loading">
                                                    <v-icon>done</v-icon>Enviar Recuperar
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                            
                                </v-form>

                            </v-card-text>

                        </v-tab-item>

                        <v-tab-item :key="'in-report'">
                          <v-form ref="formreporte" lazy-validation>
                                <v-container grid-list-md text-xs-center>

                                    <v-row row wrap>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                        model.fecha_de = parseDate(model.fecha_de)
                                                                        " v-mask="'####-##-##'" :rules="[
                                                                        rules.required,
                                                                        validaDias,
                                                                        validaFecha,
                                                                        ]">
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu3 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu3 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                            rules.required,
                                                            validaDias,
                                                            validaFecha,
                                                            ]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu4 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu4 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                         
                                          </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          <v-btn rounded color="secondary" @click="cargar()" >
                                                <v-icon>search</v-icon>Consultar
                                            </v-btn>
                                          </v-col>
                                    </v-row>

                                </v-container>
                            </v-form>
                            <v-card-actions>
                          
                                <v-spacer></v-spacer>

                            </v-card-actions>
                            <v-card-text>

                                <v-client-table ref="principalTable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2">
                                    <template slot="noResults">
                                        <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                    </template>

                                    <template slot="detail" slot-scope="props">
                                        <v-btn icon color="primary" title="Mostrar Archivos" @click="showDetail(props.row)">
                                            <v-icon v-if="registro_seleccionado != props.row.id">add_circle</v-icon>
                                            <v-icon v-if="registro_seleccionado == props.row.id">remove_circle</v-icon>
                                        </v-btn>
                                    </template>
                                    <template slot="actions" slot-scope="props">

                                        <v-btn text icon color="blue" title="Editar" @click="editar(props.row)">
                                            <v-icon dark>edit</v-icon>
                                        </v-btn>
                                     
                                        <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminar(props.row.id)">
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                    </template>

                                    <template slot="child_row">
                                        <v-toolbar dense height="35pt">
                                            <v-toolbar-title><span style="font-size:12pt">Archivos:</span></v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text>
                                            <div class="row">
                                                <v-spacer></v-spacer>
                                                <div class="col-xs-1">
                                                    <exportar-excel :data="dias.items" :exportFields="dias.camposexcel" :name="'ConsultaPatente' + registro_seleccionado + '.xlsx'">
                                                        <v-btn fab dark small color="success" title="Exportar" v-tippy>
                                                            <v-icon dark>get_app</v-icon>
                                                        </v-btn>
                                                    </exportar-excel>

                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-xs-10"></div>
                                            </div>
                                            <v-client-table ref="detailtable" :data="dias.items" :columns="columnsDias" :options="optionsDias" class="elevation-2 pa-2">
                                                <template slot="noResults">
                                                    <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                                </template>

                                            </v-client-table>
                                        </v-card-text>
                                        <hr>

                                    </template>
                                </v-client-table>
                            </v-card-text>
                        </v-tab-item>

                    </v-tabs>

                </base-material-card>
            </v-col>
        </v-row>
    </v-container>
<v-dialog v-model="modal_edit" max-width="500px">
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modal_edit = false" class="white--text" >cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Editar Solicitud</strong>
                    </span>
                </v-card>                
                
            </v-card-title>
            <v-card-text>
                <v-form ref="form_edit" lazy-validation>                    
                        <v-row>
                            <v-col cols="12">
                                <v-text-field label="Número de Referencia" type="text" 
                                        v-model="model_editable.descripcion"  :rules="[rules.required]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-switch
                                    v-model="sellos_patente"
                                    color="red darken-3" 
                                    label="Sellos de Agente"
                                ></v-switch>
                                <v-autocomplete v-if="sellos_patente" clearable item-value="id" item-text="text" chips small-chips no-data-text="No se localizaron sellos de patentes" :items="patentes" v-model="patente" label="Patente" :hide-no-data="false" ></v-autocomplete>                            
                            </v-col>                            
                        </v-row>
                        <v-row>
                            <v-col cols="12">                        
                                <h5>Ingrese lista de eDocuments</h5>
                                <v-textarea outlined rows="10" v-model="listado"></v-textarea>
                            </v-col>                            
                        </v-row>                                
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="model_editable.descripcion !='' && ((sellos_patente && patente > 0 && listado != '' ) || (!sellos_patente && listado != '' ))" rounded color="red" @click="editar_proceso" :loading="loading">
                    <v-icon>done</v-icon>Guardar Cambios
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";


export default {
  
    created: function () {
        this.URL = this.$hostname;
        this.loading = false;
        this.model.usuario = this.$local_storage.get("id_usuario");
        this.model.rfc = this.$local_storage.get("rfc");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario")
            this.permisoEliminar = true;
        this.getPatentes();
        this.cargarErrores();
         var f = new Date();
         var f_de = new Date();

              f_de.setDate(f_de.getDate() + 1);

               

                let y_de = f_de.getFullYear();
                let m_de = f_de.getMonth() + 1;
                let d_de = f_de.getDate();

                if (m_de < 10)
                    m_de = '0' + m_de;
                if (d_de < 10)
                    d_de = '0' + d_de;

                let y = f.getFullYear();
                let m = f.getMonth() + 1;
                let d = f.getDate();

              
                if (m < 10)
                    m = '0' + m;
                if (d < 10)
                    d = '0' + d;
               

                this.model.fecha_de = y + "-" + m + "-" + d;
                this.model.fecha_a = y_de + "-" + m_de + "-" + d_de;
       
    },
    data: () => ({

        registro_seleccionado: '',
        mes: "",
        listado: "",
        dialog1: false,
        modal_edit: false,
        model_editable: {},
        menu: false,
        menu1: false,
        menu2: false,
        patente: "",
        sellos_patente:false,
        patentes: [],
        to_download: [],
        emisores: [],
        norecuperados: true,
        emisor_seleccionado: "",
        allChecked: false,
        permisoEliminar: false,
        tab: null,
        lista_filtrada: [],
        lista_filtrada_acuses: [],
        errores_ws: [],
        errores: [],
        errores_columns: ["fecha", "error"],
        errores_options: {
            filterable: ["fecha", "error"],
            sortable: ["fecha", "error"],
        },
        modalErroresRecuperacion: false,
        intentosRecuperacion: 0,
        mensajeErrores: '',
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Recuperaciones de eDocuments",
                disabled: true,
                to: ""
            }
        ],

        dialog1: false,
        dialog2: false,
        modal_recuperacion: false,
        modal_acuses: false,
        modal_emisores: false,
        dialogListado: false,
        listado: "",
        datos: [],
         dias: {
            items: [],
            camposexcel: {
                "Nombre": "edocument",
                "Fecha Actualización eDocument": "fecha",
                "Estatus eDocument": "estatus",
                "Error eDocument": "error",
                "Estatus Acuse": "acuse",
                "Fecha Actualización Acuse": "fecha",
                "Error Acuse": "error"

            },
        },
        columnsDias: [

            "edocument",
            "estatus",
            "fecha",
            "error",
            "acuse",
            "fecha_acuse",
            "error_acuse"
        ],
        optionsDias: {
            filterable: [
                "edocument",
                "fecha",
                "estatus",
                "acuse",
                "error",
                "fecha_acuse",
                "error_acuse"
            ],
            sortable: [
                "edocument",
                "fecha",
                "estatus",
                "acuse",
                "error",
                "fecha_acuse",
                "error_acuse"
            ],
            orderBy: {
                column: 'fecha',
                ascending: false
            },
            headings: {
               
                "edocument": "Nombre",
                "fecha": "Fecha eDocument",
                "estatus": "Estatus eDocument",
                "error": "Error eDocument",
                "acuse": "Estatus Acuse",
                "fecha_acuse": "Fecha Acuse",
                "error_acuse": "Error Acuse"
            },
        },
        columns: ["detail", "fecha", "descripcion", "patente",  "total", "recuperados", "fallidos", "pendientes", "avance", "estatus", "actions"],
        options: {
            filterable: ["fecha", "descripcion","patente",  "estatus", ],
            sortable: ["fecha", "descripcion", "patente",  "estatus", ],
            orderBy: {
                column: 'id',
                ascending: false
            },
            headings: {
                detail: '',
                fecha: "Solicitado",
                descripcion:"Nombre",
                patente: "Patente",
                estatus: "Estatus",
                total: "Total Archivos",
                recuperados: "Procesados",
                fallidos: "Fallidos",
                pendientes: "Pendientes",
                avance: "% Avance",
                actions: "Operaciones"
            },
            uniqueKey: "id",
        },
        loading: true,
        show_loading: true,
        acuses: [],
        model: {
            rfc: "",
            usuario: "",
            pedimento: "",
            fecha_de: "",
            fecha_a: "",
            descripcion: "",
            reporte_url: "/reportes_vucem/recuperaciones_ws/",
            nombre_reporte: "Recuperaciones WS",
            tipo: "Recuperaciones WS",
            tipo_reporte: "",
            norecuperados: 0,
            archivo: "", //para buscar por nombre de archivo (pedimento|cove|edocument)
        },
        model_recuperacion: {
            rfc: '',
            archivos: '',
        },
        model_acuses: {
            id_documento: "",
            edocument: "",
            emisor: "",
        },
        errores_ws: [],
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: false,
        menu5: false,
        menu6: false,
        rules: {
            required: v => !!v || "Este campo es requerido",
            numeric: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            }
        },
    }),
    computed: {

        superusuario() {
            return this.$local_storage.get("tipo_usuario") == "Super Usuario";
        },

    },
    methods: {

        getNumeroPatente: function (id) {

            let encontrada = this.patentes.find(e => e.id == id);
            if (encontrada != undefined)
                return encontrada.text;
            else
                return "";
        },
        getPatentes: function () {
            let self = this;
            var data = {
                cliente: this.$local_storage.get("rfc"),
                headers: {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                }
            };
            axios
                .post(
                    this.$hostname + "catalogos/certificados/list_certificados_agentes/",
                    data
                )
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        res.data.forEach(function (r) {
                            self.patentes.push({
                                "id": r.id,
                                "text": r.patente + "-" + r.curp
                            });

                        });
                    }
                })
                .catch(err => {

                    console.log(err);
                });
        },
        editar: function(row){            
            this.model_editable = row;
            if (this.model_editable.tipo_clave_ws == 1){
                this.sellos_patente = true;
            }
            this.patente = this.model_editable.id_certificado;
            //console.log("Modelo: ", this.model_editable);
            
            this.listado = "";
            this.model_editable.archivos.forEach(element => {
                this.listado += element.edocument+"\n";
            });
            this.modal_edit = true;
        },
        eliminar: function (idreporte) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar la solicitud?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    var datos = {
                        id: idreporte,
                    }
                    axios.post(this.$hostname + 'vucem/delete_solicitud_edocs_agente/', datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El proceso se eliminó correctamente",
                                footer: ""
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el proceso. Favor de comunicarse con soporte.",
                                footer: '',
                            });
                            console.log(error);
                        }).then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargar();
                        });
                }
            });
        },
        cargar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                fecha_de: this.model.fecha_de,
                fecha_a: this.model.fecha_a, 
            };
            axios.post(this.URL + "vucem/list_solicitudes_edocs_agente/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos = res.data;

                        for (var k in this.datos) {

                            this.datos[k].fecha = this.parseDate(this.datos[k].fecha);
                            this.datos[k].fecha_acuse = this.parseDate(this.datos[k].fecha_acuse);
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            this.datos[k].acuse = this.getEstatus(this.datos[k].acuse);
                            this.datos[k].patente = this.getNumeroPatente(this.datos[k].id_certificado);
                           
                            let archivos = this.datos[k].archivos;
                     
                            this.datos[k].total = archivos.length * 2;
                           
                               this.datos[k].recuperados = archivos.filter(e => e.estatus == 1 ).length + archivos.filter(e => e.acuse == 1).length;
                            this.datos[k].fallidos = archivos.filter(e => e.estatus == 2 ).length + archivos.filter(e =>  e.acuse == 2).length;
                       
                            this.datos[k].pendientes = this.datos[k].total - this.datos[k].recuperados - this.datos[k].fallidos;
                            let avance = parseInt((this.datos[k].fallidos + this.datos[k].recuperados) / this.datos[k].total * 100);
                            this.datos[k].avance = "% " + avance;
                            if (avance > 0 && avance < 100)
                                this.datos[k].estatus = this.getEstatus(3);
                            else
                                this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getEstatus: function (estatus) {
            var arr_estatus = ["Pendiente", "Procesado", "Fallido", "En Proceso"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return estatus;
        },
         validaFecha: function (fecha) {
            if (fecha == "Invalid date") return "Fecha no válida.";
            else return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            }
            return true;
        },
       
        validaDias: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 365)
                    return "Periodo máximo de consulta 365 dias. Favor de verificar.";
            }
            return true;
        },
      
        removerLineasVacias(listado) {
            var listadoSplit = this.listado.split("\n");
            var listadoSinEspacios = listadoSplit.filter(item => {
                return item.trim() != "";
            });
            return listadoSinEspacios;
        },

        parseDate(date) {
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        clear_values() {
            this.model.pedimento = '';
            this.model.fecha_de = '';
            this.model.fecha_a = '';
            this.model.archivo = '';
            this.listado = "";
        },

        downloadReporte: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        showDetail: function (row) {
            if (this.registro_seleccionado != row.id) {
                this.registro_seleccionado = row.id;
                this.cargarDias();
                var detallesAbiertos = this.$refs.principalTable.openChildRows;
                for (var k in detallesAbiertos) { //Cerramos detalles abiertos
                    if (detallesAbiertos[k] != row.id)
                        this.$refs.principalTable.toggleChildRow(detallesAbiertos[k]);
                }
            } else { //Significa que dio clic en '-' solo cerramos el detalle y no hacemos nada
                this.registro_seleccionado = '';
            }
            this.$refs.principalTable.toggleChildRow(row.id); //Mostramos detalle seleccionado

        },
        cargarDias: function () {
            let self = this;
            let encontrada = self.datos.find(e => e.id == self.registro_seleccionado);
            this.dias.items = encontrada.archivos;
            for (var k in this.dias.items) {
                this.dias.items[k].fecha = this.parseDate(this.dias.items[k].fecha);
                this.dias.items[k].fecha_acuse = this.parseDate(this.dias.items[k].fecha_acuse);
                this.dias.items[k].estatus = this.getEstatus(this.dias.items[k].estatus);
                this.dias.items[k].acuse = this.getEstatus(this.dias.items[k].acuse);
                this.dias.items[k].error = this.getErrorWS(this.dias.items[k].error);

            }

        },
     cargarErrores: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios.get(this.$hostname + "catalogos/errores_ws/")
        .then(res => {
          this.errores_ws = res.data;
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el catálogo de errores webservice.",
            footer: ""
          });
        }).then(() => {
          this.cargar();
        });
    },
     getErrorWS: function(errorWs) {
      if (errorWs != null && errorWs.toString().trim() != "") {
        var filter = this.errores_ws.filter(function(e) {
          return e.error.toString().trim().toLowerCase() == errorWs.toString().trim().toLowerCase();
        });
        if (filter.length > 0) {
          return filter[0].metadato;
        } else
          return errorWs;
      } else
        return errorWs;

    },
        crearproceso() {
            let self = this;
            self.$swal({
                type: "info",
                title: "Confirme",
                text: "¿Desea enviar los eDocuments al proceso de recuperación?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    self.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                    let archivos = [];
                    let coves = self.listado.split("\n");
                    let id_certificado = 0;
                    let tipo_certificado = 0;
                    coves.forEach(function(c){
                        if(c.trim() != "")
                            archivos.push({'edocument':c.trim()})
                    });
                    if (self.sellos_patente){
                        tipo_certificado = 1;
                        id_certificado = self.patente;
                    }
                  
                    let data = {

                        "rfc": self.model.rfc,
                        "tipo_clave_ws": tipo_certificado,
                        "id_certificado": id_certificado,
                        "archivos": archivos,
                        "descripcion": self.model.descripcion,
                        "id_usuario": self.model.usuario,
                        "id_cliente": self.$local_storage.get("id_cliente")

                    };
                     
                   axios.post(self.$hostname + "vucem/solicitud_edocs_agente/", data)
                        .then(res => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación exitosa!",
                                text: "El proceso se envió correctamente",
                                footer: ""
                            });
                            self.cargar();
                        })
                        .catch(err => {
                            var msj = "";
                            if (err.response != undefined && err.response.data != undefined && err.response.data.mensaje != undefined)
                                msj = err.response.data.mensaje;
                            self.$root.$dialogLoader.hide();
                            this.$swal({
                                type: "error",
                                title: "¡Operación no permitida!",
                                text: "Ocurrio un error al crear la solicitud",
                                footer: msj
                            });
                            //Puede ser que regrese un timeout, pero igualmente se mostrará mensaje de exito
                        }).then(() => {
                            self.$root.$dialogLoader.hide();
                        }); 

                }

            });

        },
        editar_proceso() {
            let self = this;

            if (!this.$refs.form_edit.validate()) { 
                return false;
            }
            
            self.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            let archivos = [];
            let coves = self.listado.split("\n");
            let id_certificado = 0;
            let tipo_certificado = 0;
            coves.forEach(function(c){
                if(c.trim() != "")
                    archivos.push(c.trim())
            });
            if (self.sellos_patente){
                tipo_certificado = 1;
                id_certificado = self.patente;
            }
            
            let data = {
                "tipo":"edocument",
                "id": self.model_editable.id,
                "rfc": self.model_editable.rfc,
                "tipo_clave_ws": tipo_certificado,
                "id_certificado": id_certificado,
                "archivos": archivos,
                "descripcion": self.model_editable.descripcion,
                "id_usuario": self.model.usuario,
                "id_cliente": self.$local_storage.get("id_cliente")
            };

            axios.post(self.$hostname + "vucem/edit_solicitud_agente/", data)
                .then(res => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación exitosa!",
                        text: "El registro se guardó correctamente",
                        footer: ""
                    });
                    self.cargar();
                })
                .catch(err => {
                    var msj = "";
                    if (err.response != undefined && err.response.data != undefined && err.response.data.mensaje != undefined)
                        msj = err.response.data.mensaje;
                    self.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no permitida!",
                        text: "Ocurrio un error al guardar la solicitud",
                        footer: msj
                    });
                    //Puede ser que regrese un timeout, pero igualmente se mostrará mensaje de exito
                }).then(() => {
                    self.$root.$dialogLoader.hide();
                    self.modal_edit = false;
                });                

        },

    },
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: xx-small !important;
}
</style>
